import { HttpContextToken } from '@angular/common/http';

export const BYPASS_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);